import { useMemo } from 'react';
import { useGetColumnDisplayName } from 'apps/sigma2-ui/src/explore-section/hooks/useGetColumnDisplayName';
import { TableViewCompatibleData } from 'libs/end-to-end/src/custom-viz/TableViewTypes';
import { ViewConfigurationSchema } from 'libs/end-to-end/src/view-configurations';

export const useTableViewXAxisLabel = ({
  data,
  viewConfiguration,
}: {
  data: TableViewCompatibleData;
  viewConfiguration: ViewConfigurationSchema;
}): string => {
  const { getColumnDisplayName } = useGetColumnDisplayName();

  return useMemo(() => {
    const filterOptions = data.filtersToBreakdown ?? [];
    if (filterOptions.length > 0) {
      const selectedFilter = viewConfiguration.selectedFilterDefinition;
      const selectedOption =
        filterOptions.find((option) => option.value === selectedFilter) ??
        filterOptions[0];

      if (selectedOption?.label) {
        return selectedOption.label;
      }
    }

    if (!data.selectedGroupBy) {
      return '';
    }

    return getColumnDisplayName(data.selectedGroupBy);
  }, [
    data.filtersToBreakdown,
    data.selectedGroupBy,
    getColumnDisplayName,
    viewConfiguration.selectedFilterDefinition,
  ]);
};
